import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { FuseNavigationService } from '@fuse/components/navigation/navigation.service';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { ParseService } from 'app/shared/common/parse/parse.service';

@Injectable({
  providedIn: 'root'
})

export class AuthGuardService implements CanActivate {

  /** Constructor
  *   @param {FuseNavigationService} _fuseNavigationService
  */

  constructor(
    private router: Router,
    private _fuseNavigationService: FuseNavigationService,
    private storageConfiguration: StorageConfiguration,
    private parseService: ParseService,
  ) {
  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

    /**
     * * Roles allowed rote paths
     */

    const permission = {
      'Admin': ['employees-experience-details', 'settings', 'clients', 'activity-center', 'performance-review', 'team-violation', 'violations', 'holidays', 'team-leave',
        'my-leave', 'calendar', 'user-timesheet', 'my-team', 'team-sheet', 'on-going-project-list', 'attendance', 'long-leave-employees', 'released-employees', 'CheckInOut',
        'employees-details', 'employees-dashboard', 'todo-list-item', 'work-status', 'employees-tasks', 'project-metrics', 'onboarding',
        'plan-subscribe', 'login', 'profile', 'reset-password', 'desktop-apps-download', 'project-detail', 'scrumboard', 'project-create', 'client-create', 'interview-info',
        'create-review', 'profile-view', 'jobs', 'plans', 'metrics', 'metrics-details', 'timesheet-view', 'client-list', 'analytics-dashboard', 'yearly-dashboard', 'on-hold-project-list'],

      'Leader': ['project-metrics', 'work-status', 'employees-dashboard', 'team-sheet', 'employees-tasks', 'employees-details', 'released-employees', 'long-leave-employees',
        'attendance', 'on-going-project-list', 'todo-list-item', 'my-team', 'user-timesheet', 'calendar', 'my-leave', 'team-leave', 'holidays', 'activity-center',
        'violations', 'team-violation', 'performance-review', 'login', 'profile', 'reset-password', 'CheckInOut', 'desktop-apps-download', 'project-detail', 'scrumboard', 'timesheet-view', 'yearly-dashboard',
        'profile-view', 'create-review', 'on-hold-project-list', 'interview-info'],

      'IT Manager': ['employees-dashboard', 'employees-details', 'team-sheet', 'released-employees', 'long-leave-employees', 'attendance', 'on-going-project-list', 'todo-list-item', 'calendar',
        'my-leave', 'team-leave', 'holidays', 'my-team', 'user-timesheet', 'violations', 'team-violation', 'login', 'profile', 'reset-password', 'yearly-dashboard',
        'desktop-apps-download', 'project-detail', 'CheckInOut', 'scrumboard', 'timesheet-view', 'profile-view', 'create-review', 'on-hold-project-list', 'interview-info'],

      'Employee': ['violations', 'holidays', 'my-leave', 'calendar', 'user-timesheet', 'my-team', 'on-going-project-list', 'employees-dashboard', 'todo-list-item',
        'login', 'profile', 'reset-password', 'desktop-apps-download', 'project-detail', 'scrumboard', 'on-hold-project-list'],
    };
    /**end */

    const role = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);
    /**
     * * check the user role against allowed roles
     */

    if (permission[role] !== undefined) {
      if (permission[role].includes(state.url.split('/')[1].split(';')[0]) === false) {
        this.router.navigate(['login']);
        return false;
      }
      if (permission[role].includes(state.url.split('/')[1].split(';')[0]) === false && state.url.search('/plans?') === -1) {
        this.router.navigate(['login']);
        return false;
      } else {
        if (state.url.search('/plans?') !== -1) {
          if (permission[role].includes('plans') === false) {
            this.router.navigate(['login']);
            return false;
          }
        }
      }
    } else {
      if (permission['Employee'].includes(state.url.split('/')[1]) === false) {
        this.router.navigate(['login']);
        return false;
      }
    }
    /** end */
    let url: string = state.url;
    let isloggedIn = this.storageConfiguration.sessionGetItem(this.storageConfiguration.isloggedIn);
    let navigationAdded = false;
    if (isloggedIn == 'true') {
      var currentNavigation = this._fuseNavigationService.getCurrentNavigation();
      currentNavigation.forEach(element => {
        if (element.id == 'pages') {
          navigationAdded = true;
        }
      });

      if (!navigationAdded) {
        var empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);
        const customFunctionNavItem = {
          'id': 'pages',
          'title': '',
          'type': 'group',
          'icon': 'pages',
          'children': this.getPages(empRole)
        };
        this._fuseNavigationService.addNavigationItem(customFunctionNavItem, 'start');
      }
      let urlValue = url.split(';')
      this.filterUrl(urlValue[0]);
      return true;
    }
    this.router.navigate(['login']);
    return false;
  }

  filterUrl(url) {

    if (url !== '/employees') {
      if (url !== '/profile-view') {
        if (url !== '/timesheet-view') {
          if (url !== '/employees-dashboard') {
            if (url !== '/yearly-dashboard') {
              localStorage.removeItem('employeesTable');
              localStorage.removeItem('releasedTable');
              localStorage.removeItem('longLeaveTable');
            }
          }
        }
      }
    }
    if (url !== '/projects') {
      if (url !== '/project-detail') {
        if (url !== '/project-list') {
          localStorage.removeItem('projectsTable');
          localStorage.removeItem('projectsOnGoingTable');
          localStorage.removeItem('projectsCompletedTable');
        }
      }
    }
    if (url !== '/clients') {
      if (url !== '/client-create') {
        localStorage.removeItem('clientTable');
      }
    }

  }

  getPages(empRole) {
    switch (empRole) {
      case 'Admin':
        return this.getAdmin();
      case 'Leader':
        return this.getLeaderPage();
      case 'IT Manager':
        return this.getItManagerPages();
      default:
        return this.getEmployeePages();
    }
  }

  getAdmin() {
    let modules = [];
    modules = this.getAdminPages();
    // let currentUser = this.parseService.instance.User.current();
    // if (currentUser.id == 'NJt11DneE5') {
    //   modules.push(
    //     {
    //       id: 'jobs',
    //       title: 'Jobs',
    //       type: 'item',
    //       icon: 'work',
    //       url: 'jobs',
    //     }
    //   );
    // }
    return modules;
  }

  getAdminPages() {
    return [
      {
        id: 'onboarding',
        title: 'Onboarding',
        type: 'item',
        icon: 'library_books',
        url: '/onboarding',
      },
      {
        id: 'dashboards',
        title: 'Dashboards',
        type: 'collapsable',
        icon: 'dashboard',
        children: [
          {
            id: 'project-metrics',
            title: 'Project Metrics',
            type: 'item',
            icon: 'assessment',
            url: '/project-metrics'
          },
          {
            id: 'tasks-metrics',
            title: 'Task Metrics',
            type: 'item',
            icon: 'list',
            url: '/employees-tasks'
          },
          {
            id: 'work-status',
            title: 'Work Status',
            type: 'item',
            icon: 'assessment',
            url: '/work-status'
          },
          {
            id: 'employees-dashboard',
            title: 'My Time',
            type: 'item',
            icon: 'access_time',
            url: '/employees-dashboard'
          },
          {
            id: 'analytics',
            title: 'Resource Analytics',
            type: 'item',
            icon: 'show_chart',
            url: '/analytics-dashboard'
          },
          {
            id: 'timesheet-dashboard',
            title: 'Check-In / Out Report',
            type: 'item',
            icon: 'restore',
            url: '/CheckInOut'
          },
          // {
          //   id: 'page-visit',
          //   title: 'Page Visit',
          //   type: 'item',
          //   icon: 'pageview',
          //   url: '/page-visit'
          // },
        ]
      },
      // {
      //   id: 'scrumboard',
      //   title: 'Scrumboard',
      //   type: 'item',
      //   icon: 'assessment',
      //   url: 'scrumboard/boards'
      // },
      {
        id: 'employees',
        title: 'Employees',
        type: 'collapsable',
        icon: 'account_box',
        children: [
          {
            id: 'employees-details',
            title: 'Employees Details',
            type: 'item',
            icon: 'today',
            url: '/employees-details'
          },
          {
            id: 'released-employees',
            title: 'Ex-employees',
            type: 'item',
            icon: 'today',
            url: '/released-employees'
          },
          {
            id: 'long-leave-employees',
            title: 'Long Leave Employees',
            type: 'item',
            icon: 'today',
            url: '/long-leave-employees'
          },
          {
            id: 'employees-experience-details',
            title: 'Experience Levels',
            type: 'item',
            icon: 'today',
            url: '/employees-experience-details'
          },
          {
            id: 'attendance',
            title: 'Check-in & Check-out',
            type: 'item',
            icon: 'library_books',
            url: '/attendance',
          },
          {
            id: 'interview-info',
            title: 'Interview Log',
            type: 'item',
            icon: 'library_books',
            url: '/interview-info',
          }
        ]
      },
      // {
      //   id: 'projects',
      //   title: 'Projects',
      //   type: 'item',
      //   icon: 'library_books',
      //   url: '/projects',
      // },
      {
        id: 'projects',
        title: 'Projects',
        type: 'collapsable',
        icon: 'library_books',
        children: [
          {
            id: 'on-going-project-list',
            title: 'On Going',
            type: 'item',
            icon: 'people_outline',
            url: '/on-going-project-list',
          },
          {
            id: 'on-hold-project-list',
            title: 'On Hold / Completed',
            type: 'item',
            icon: 'restore',
            url: '/on-hold-project-list',
          },
          // {
          //   id: 'admin-addons-list',
          //   title: 'Add ons',
          //   type: 'item',
          //   icon: 'restore',
          //   url: '/admin-addons-list',
          // },
          // {
          //   id: 'todo',
          //   title: 'Task',
          //   type: 'item',
          //   icon: 'today',
          //   url: 'todo-list-item',
          // },
        ]
      },
      {
        id: 'todo',
        title: 'Task',
        type: 'item',
        icon: 'today',
        url: 'todo-list-item',
      },
      {
        id: 'team',
        title: 'Team',
        type: 'collapsable',
        icon: 'people_outline',
        children: [
          // {
          //   id: 'my-team',
          //   title: 'My Team',
          //   type: 'item',
          //   icon: 'people_outline',
          //   url: '/my-team',
          // },
          {
            id: 'team-sheet',
            title: 'My Team',
            type: 'item',
            icon: 'people_outline',
            url: '/team-sheet',
          },
          {
            id: 'user-timesheet',
            title: 'My Timesheet',
            type: 'item',
            icon: 'restore',
            url: '/user-timesheet',
          }
        ]
      },
      // {
      //   id: 'todo',
      //   title: 'To Do',
      //   translate: 'NAV.TODO',
      //   type: 'item',
      //   icon: 'today',
      //   url: 'todo/all',
      // },
      {
        id: 'calendar',
        title: 'Calendar',
        type: 'collapsable',
        icon: 'calendar_today',
        children: [
          {
            id: 'leave',
            title: 'Leave',
            type: 'item',
            icon: 'today',
            url: '/calendar'
          },
          {
            id: 'my-leave',
            title: 'My Leaves',
            type: 'item',
            icon: 'person',
            url: '/my-leave'
          },
          {
            id: 'team-leave',
            title: 'Team Leaves',
            type: 'item',
            icon: 'people',
            url: '/team-leave'
          },
          {
            id: 'holidays',
            title: 'Holidays',
            type: 'item',
            icon: 'check_circle',
            url: '/holidays'
          }
        ]
      },
      {
        id: 'availability',
        title: 'Availability Status',
        type: 'collapsable',
        icon: 'report',
        children: [
          {
            id: 'my-availability-status',
            title: 'My Availability Status',
            type: 'item',
            url: '/violations',
          },
          {
            id: 'team-availability-status',
            title: 'Team Availability Status',
            type: 'item',
            url: '/team-violation',
          }
        ]
      },
      {
        id: 'performance-review',
        title: 'Performance Review',
        type: 'item',
        icon: 'library_books',
        url: '/performance-review',
      },

      {
        id: 'activity-center',
        title: 'Activity Center',
        type: 'item',
        icon: 'library_books',
        url: '/activity-center',
      },
      {
        id: 'clients',
        title: 'Clients',
        type: 'item',
        icon: 'people_outline',
        url: '/clients',
      },
      {
        id: 'settings',
        title: 'Settings',
        type: 'collapsable',
        icon: 'report',
        children: [
          // {
          //   id: 'create-location',
          //   title: 'Create Location',
          //   type: 'item',
          //   url: '/create-location',
          // },
          // {
          //   id: 'create-organization',
          //   title: 'Create Organization',
          //   type: 'item',
          //   url: '/create-organization',
          // },
          // {
          //   id: 'default-task',
          //   title: 'Default Task',
          //   type: 'item',
          //   url: '/default-task',
          // },
          {
            id: 'system-setting',
            title: 'Organization Setting',
            type: 'item',
            url: '/settings',
          },
          {
            id: 'metrics',
            title: 'Metrics',
            url: '/metrics',
          }
        ]
      },
      // {
      //   id: 'opportunity-list',
      //   title: 'Opportunity',
      //   type: 'item',
      //   icon: 'assessment',
      //   url: '/opportunity-list'
      // },
      // {
      //   id: 'projects-commit',
      //   title: 'Gitlab Report',
      //   type: 'item',
      //   icon: 'library_books',
      //   url: '/projects-commit'
      // },
      {
        id: 'support',
        title: 'Support',
        type: 'item',
        icon: 'headset_mic',
        url: 'https://support.whatsdare.com/auth/login',
        externalUrl: true,
        openInNewTab: true
      }
    ];
  }

  getLeaderPage() {
    return [
      {
        id: 'dashboards',
        title: 'Dashboards',
        type: 'collapsable',
        icon: 'dashboard',
        children: [
          {
            id: 'project-metrics',
            title: 'Project Metrics',
            type: 'item',
            icon: 'assessment',
            url: '/project-metrics'
          },
          {
            id: 'work-status',
            title: 'Work Status',
            type: 'item',
            icon: 'assessment',
            url: '/work-status'
          },
          {
            id: 'employees-dashboard',
            title: 'My Time',
            type: 'item',
            icon: 'dashboard',
            url: '/employees-dashboard'
          },
          {
            id: 'tasks-metrics',
            title: 'Task Metrics',
            type: 'item',
            icon: 'list',
            url: '/employees-tasks'
          },
          {
            id: 'timesheet-dashboard',
            title: 'Check-In/Out Report',
            type: 'item',
            icon: 'restore',
            url: '/CheckInOut'
          }
          // {
          //   id: 'page-visit',
          //   title: 'Page Visit',
          //   type: 'item',
          //   icon: 'pageview',
          //   url: '/page-visit'
          // }
        ]
      },
      // {
      //   id: 'scrumboard',
      //   title: 'Scrumboard',
      //   type: 'item',
      //   icon: 'assessment',
      //   url: 'scrumboard/boards'
      // },
      {
        id: 'employees',
        title: 'Employees',
        type: 'collapsable',
        icon: 'account_box',
        children: [
          {
            id: 'employees-details',
            title: 'Employees Details',
            type: 'item',
            icon: 'today',
            url: '/employees-details'
          },
          {
            id: 'released-employees',
            title: 'Ex-employees',
            type: 'item',
            icon: 'today',
            url: '/released-employees'
          },
          {
            id: 'long-leave-employees',
            title: 'Long Leave Employees',
            type: 'item',
            icon: 'today',
            url: '/long-leave-employees'
          },
          {
            id: 'attendance',
            title: 'Check-in & Check-out',
            type: 'item',
            icon: 'library_books',
            url: '/attendance',
          },
          {
            id: 'interview-info',
            title: 'Interview Log',
            type: 'item',
            icon: 'library_books',
            url: '/interview-info',
          }
        ]
      },
      // {
      //   id: 'projects',
      //   title: 'Projects',
      //   type: 'item',
      //   icon: 'library_books',
      //   url: '/projects',
      // },
      {
        id: 'projects',
        title: 'Projects',
        type: 'collapsable',
        icon: 'library_books',
        children: [
          {
            id: 'on-going-project-list',
            title: 'On Going',
            type: 'item',
            icon: 'people_outline',
            url: '/on-going-project-list',
          },
          // {
          //   id: 'on-hold-project-list',
          //   title: 'On Hold/Completed',
          //   type: 'item',
          //   icon: 'restore',
          //   url: '/on-hold-project-list',
          // },
          // {
          //   id: 'todo',
          //   title: 'Task',
          //   type: 'item',
          //   icon: 'today',
          //   url: 'todo-list-item',
          // },
        ]
      },
      {
        id: 'todo',
        title: 'Task',
        type: 'item',
        icon: 'today',
        url: 'todo-list-item',
      },
      {
        id: 'team',
        title: 'Team',
        type: 'collapsable',
        icon: 'people_outline',
        children: [
          // {
          //   id: 'my-team',
          //   title: 'My Team',
          //   type: 'item',
          //   icon: 'people_outline',
          //   url: '/my-team',
          // },
          {
            id: 'team-sheet',
            title: 'My Team',
            type: 'item',
            icon: 'people_outline',
            url: '/team-sheet',
          },
          {
            id: 'user-timesheet',
            title: 'My Timesheet',
            type: 'item',
            icon: 'restore',
            url: '/user-timesheet',
          }
        ]
      },
      {
        id: 'calendar',
        title: 'Calendar',
        type: 'collapsable',
        icon: 'calendar_today',
        children: [
          {
            id: 'leave',
            title: 'Leave',
            type: 'item',
            icon: 'today',
            url: '/calendar'
          },
          {
            id: 'my-leave',
            title: 'My Leaves',
            type: 'item',
            icon: 'person',
            url: '/my-leave'
          },
          {
            id: 'team-leave',
            title: 'Team Leaves',
            type: 'item',
            icon: 'people',
            url: '/team-leave'
          },
          {
            id: 'holidays',
            title: 'Holidays',
            type: 'item',
            icon: 'check_circle',
            url: '/holidays'
          }
        ]
      },
      {
        id: 'activity-center',
        title: 'Activity Center',
        type: 'item',
        icon: 'library_books',
        url: '/activity-center',
      },
      {
        id: 'availability',
        title: 'Availability Status',
        type: 'collapsable',
        icon: 'report',
        children: [
          {
            id: 'my-availability-status',
            title: 'My Availability Status',
            type: 'item',
            url: '/violations',
          },
          {
            id: 'team-availability-status',
            title: 'Team Availability Status',
            type: 'item',
            url: '/team-violation',
          }
        ]
      },
      {
        id: 'performance-review',
        title: 'Performance Review',
        type: 'item',
        icon: 'library_books',
        url: '/performance-review',
      },
      // {
      //   id: 'opportunity-list',
      //   title: 'Opportunity',
      //   type: 'item',
      //   icon: 'assessment',
      //   url: '/opportunity-list'
      // },
      // {
      //   id: 'projects-commit',
      //   title: 'Gitlab Report',
      //   type: 'item',
      //   icon: 'library_books',
      //   url: '/projects-commit'
      // },
      {
        id: 'support',
        title: 'Support',
        type: 'item',
        icon: 'headset_mic',
        url: 'https://support.whatsdare.com/auth/login',
        externalUrl: true,
        openInNewTab: true
      }
    ];
  }

  getEmployeePages() {
    return [
      // {
      //   id: 'employees-dashboard',
      //   title: 'Dashboard',
      //   type: 'item',
      //   icon: 'dashboard',
      //   url: '/employees-dashboard'
      // },
      {
        id: 'dashboards',
        title: 'Dashboards',
        type: 'collapsable',
        icon: 'dashboard',
        children: [
          {
            id: 'todo-list-item',
            title: 'My Tasks',
            type: 'item',
            icon: 'work',
            url: '/todo-list-item'
          },
          {
            id: 'employees-dashboard',
            title: 'My Time',
            type: 'item',
            icon: 'access_time',
            url: '/employees-dashboard'
          },
        ]
      },
      // {
      //   id: 'projects',
      //   title: 'Projects',
      //   type: 'item',
      //   icon: 'library_books',
      //   url: '/projects',
      // },
      {
        id: 'projects',
        title: 'Projects',
        type: 'collapsable',
        icon: 'library_books',
        children: [
          {
            id: 'on-going-project-list',
            title: 'On Going',
            type: 'item',
            icon: 'people_outline',
            url: '/on-going-project-list',
          },
          // {
          //   id: 'on-hold-project-list',
          //   title: 'On Hold/Completed',
          //   type: 'item',
          //   icon: 'restore',
          //   url: '/on-hold-project-list',
          // },
          // {
          //   id: 'todo',
          //   title: 'Task',
          //   type: 'item',
          //   icon: 'today',
          //   url: 'todo-list-item',
          // },
        ]
      },
      // {
      //   id: 'todo',
      //   title: 'My Tasks',
      //   type: 'item',
      //   icon: 'today',
      //   url: 'todo-list-item',
      // },
      {
        id: 'my-team',
        title: 'My Team',
        type: 'item',
        icon: 'people_outline',
        url: '/my-team',
      },
      {
        id: 'user-timesheet',
        title: 'My Timesheet',
        type: 'item',
        icon: 'restore',
        url: '/user-timesheet',
      },
      {
        id: 'calendar',
        title: 'Calendar',
        type: 'collapsable',
        icon: 'calendar_today',
        children: [
          {
            id: 'leave',
            title: 'Leave',
            type: 'item',
            icon: 'today',
            url: '/calendar'
          },
          {
            id: 'my-leave',
            title: 'My Leaves',
            type: 'item',
            icon: 'person',
            url: '/my-leave'
          },
          {
            id: 'holidays',
            title: 'Holidays',
            type: 'item',
            icon: 'check_circle',
            url: '/holidays'
          }
        ]
      },
      {
        id: 'availability',
        title: 'Availability Status',
        type: 'item',
        icon: 'report',
        url: '/violations',
      },
      {
        id: 'support',
        title: 'Support',
        type: 'item',
        icon: 'headset_mic',
        url: 'https://support.whatsdare.com/auth/login',
        externalUrl: true,
        openInNewTab: true
      }
    ]
  }

  getItManagerPages() {
    return [
      {
        id: 'employees-dashboard',
        title: 'Dashboard',
        type: 'item',
        icon: 'dashboard',
        url: '/employees-dashboard'
      },
      {
        id: 'employees',
        title: 'Employees',
        type: 'collapsable',
        icon: 'account_box',
        children: [
          {
            id: 'employees-details',
            title: 'Employees Details',
            type: 'item',
            icon: 'today',
            url: '/employees-details'
          },
          {
            id: 'released-employees',
            title: 'Ex-employees',
            type: 'item',
            icon: 'today',
            url: '/released-employees'
          },
          {
            id: 'long-leave-employees',
            title: 'Long Leave Employees',
            type: 'item',
            icon: 'today',
            url: '/long-leave-employees'
          },
          {
            id: 'attendance',
            title: 'Check-in & Check-out',
            type: 'item',
            icon: 'library_books',
            url: '/attendance',
          },
          {
            id: 'interview-info',
            title: 'Interview Log',
            type: 'item',
            icon: 'library_books',
            url: '/interview-info',
          }
        ]
      },
      {
        id: 'projects',
        title: 'Projects',
        type: 'collapsable',
        icon: 'library_books',
        children: [
          {
            id: 'on-going-project-list',
            title: 'On Going',
            type: 'item',
            icon: 'people_outline',
            url: '/on-going-project-list',
          },
          // {
          //   id: 'on-hold-project-list',
          //   title: 'On Hold/Completed',
          //   type: 'item',
          //   icon: 'restore',
          //   url: '/on-hold-project-list',
          // },
          // {
          //   id: 'todo',
          //   title: 'Task',
          //   type: 'item',
          //   icon: 'today',
          //   url: 'todo-list-item',
          // },
        ]
      },
      {
        id: 'todo',
        title: 'My Tasks',
        type: 'item',
        icon: 'today',
        url: 'todo-list-item',
      },
      {
        id: 'calendar',
        title: 'Calendar',
        type: 'collapsable',
        icon: 'calendar_today',
        children: [
          {
            id: 'leave',
            title: 'Leave',
            type: 'item',
            icon: 'today',
            url: '/calendar'
          },
          {
            id: 'my-leave',
            title: 'My Leaves',
            type: 'item',
            icon: 'person',
            url: '/my-leave'
          },
          {
            id: 'team-leave',
            title: 'Team Leaves',
            type: 'item',
            icon: 'people',
            url: '/team-leave'
          },
          {
            id: 'holidays',
            title: 'Holidays',
            type: 'item',
            icon: 'check_circle',
            url: '/holidays'
          }
        ]
      },
      {
        id: 'team',
        title: 'Team',
        type: 'collapsable',
        icon: 'people_outline',
        children: [
          // {
          //   id: 'my-team',
          //   title: 'My Team',
          //   type: 'item',
          //   icon: 'people_outline',
          //   url: '/my-team',
          // },
          {
            id: 'team-sheet',
            title: 'My Team',
            type: 'item',
            icon: 'people_outline',
            url: '/team-sheet',
          },
          {
            id: 'user-timesheet',
            title: 'My Timesheet',
            type: 'item',
            icon: 'restore',
            url: '/user-timesheet',
          }
        ]
      },
      {
        id: 'availability',
        title: 'Availability Status',
        type: 'collapsable',
        icon: 'report',
        children: [
          {
            id: 'my-availability-status',
            title: 'My Availability Status',
            type: 'item',
            url: '/violations',
          },
          {
            id: 'team-availability-status',
            title: 'Team Availability Status',
            type: 'item',
            url: '/team-violation',
          }
        ]
      },
      {
        id: 'support',
        title: 'Support',
        type: 'item',
        icon: 'headset_mic',
        url: 'https://support.whatsdare.com/auth/login',
        externalUrl: true,
        openInNewTab: true
      }
    ];
  }

}
